function useInitialOffer() {

    const getOffer = (priceMinorUnits) => {
        const off = .03; //priceMinorUnits <= 15000*100 ? .15 : .08;
        //console.log(priceMinorUnits, off)
        const priceWthOff = priceMinorUnits-priceMinorUnits*off;

        //console.log('priceWthOff', priceWthOff)

        const rounder = priceMinorUnits <= 15000*100 ? 500*100 : 1000*100;

        const priceWthOffRounded = rounder*parseInt(priceWthOff/rounder);

        //console.log('priceWthOffRounded', priceWthOffRounded)

        return priceWthOffRounded;
    }

    return {getOffer};
}

export default useInitialOffer;
